<template>
  <iframe :srcdoc="iframeSrc" class="questionnaires__questionnaire" />
</template>

<script>
// postがoptionsになってしまうため、this.$axiosは使用せずimportする
import axios from "axios"
import QuestionnaireEntity from "../../../../../common/js/entity/questionnaireEntity"

export default {
  name: "Questionnaire",
  props: {
    questionnaire: {
      type: QuestionnaireEntity,
      required: true
    }
  },
  data() {
    return {
      iframeSrc: "",
      appUrl: process.env.MIX_APP_URL,
      gPlusDomain: process.env.MIX_GPLUS_URL,
      event: {
        INIT: "init",
        CLOSE: "close"
      }
    }
  },
  mounted() {
    const params = new URLSearchParams()
    params.append("user_id", this.user.id)
    params.append("account_type", this.user.type)
    params.append("guest_name", this.user.name)

    axios
      .post(`${this.gPlusDomain}/api/v1/questionnaires/${this.questionnaire.id}`, params, {responseType: "text"})
      .then(response => {
        this.iframeSrc = response.data

        const contentWindow = this.$el.contentWindow

        window.addEventListener("message", message => {
          if (message.origin !== this.appUrl && message.origin !== this.gPlusDomain) return

          if (contentWindow !== message.source) return

          this.emitEvent(message.data.event, message.data.data)
        })
      })
      .catch(error => {
        console.log(error.response.data.message)
      })
  },
  computed: {
    user() {
      return this.$store.getters["auth/user"]
    }
  },
  methods: {
    emitEvent(eventName, data) {
      const questionnaire = this.questionnaire
      const liveQuestionnaire = this.$store.getters["liveQuestionnaire/findById"](questionnaire.id)

      switch (eventName) {
        case this.event.INIT:
          questionnaire.init(data.title, data.isExpired, data.isAnswered)

          this.$emit("init", questionnaire)

          break
        case this.event.CLOSE:
          if (!_.isEmpty(liveQuestionnaire)) {
            this.$store.dispatch("liveQuestionnaire/removeQuestionnairesById", questionnaire.id)
          }

          questionnaire.close(data.remove)

          this.$emit("close", questionnaire)

          break
      }
    }
  }
}
</script>
